
import IconArrow from '@/components/svg/IconArrow.vue'
import IconHome from '@/components/svg/IconHome.vue'
import IconLogout from '@/components/svg/IconLogout.vue'
import KeyenceHTHardKeyButton from '@/components/keyenceHT/hardkeys/KeyenceHTHardKeyButton.vue'
import { LOGOUT } from '@/store/actions'
import errorHandler from '@/utils/errorHandler'
import { KeyenceHardKey } from '@/utils/keyenceHT/keyenceHardKeyEventHandler'
import { isKeyenceEnterpriseBrowser } from '@/utils/keyenceHT/keyenceModules'
import { TError } from '@/utils/types/commonTypes'
import { Options, Vue } from 'vue-class-component'

@Options({
  components: {
    IconLogout,
    IconArrow,
    IconHome,
    KeyenceHTHardKeyButton,
  },
  name: 'AppHeader',
})
export default class AppHeader extends Vue {
  KeyenceHardKey = KeyenceHardKey

  showLogoutAlert = false

  get showHeader() {
    return this.$route.meta.header
  }

  get image() {
    return this.$store.getters.customLogoImageUrl || require('@/assets/logo-smartBarcode.png')
  }

  get isAuth() {
    return this.$store.state.profile.user !== null
  }

  get showLogo() {
    return !!this.$route.meta.header?.logo
  }

  get showHomeButton() {
    return this.$store.getters.projectParam && !!this.$route.meta.header?.homeButtton
  }

  get currentUserName() {
    const user = this.$store.state.profile.user
    return user?.fullName ?? ''
  }

  get isKeyenceEnterpriseBrowser(): boolean {
    return isKeyenceEnterpriseBrowser()
  }

  closeLogoutAlert() {
    this.showLogoutAlert = false
  }

  async logout() {
    try {
      await this.$store.dispatch(LOGOUT)
      this.showLogoutAlert = false
      this.goHome()
    } catch (error) {
      errorHandler(error as TError)
    }
  }

  goHome() {
    this.$router.push({
      name: 'home',
      params: { project: this.$store.getters.projectParam },
    })
  }
}
